import axios, { AxiosRequestConfig } from 'axios';

export type ISuccessResponse<T> = T & {
  status: 'OK';
};

export type HttpMethods = 'get' | 'post' | 'patch' | 'put' | 'delete';
export interface IHttpRequestConfig<T> extends AxiosRequestConfig<T> {
  method: HttpMethods;
  headers?: Record<string, string>;
  data?: T;
  token?: string;
}

/**
 * API request with 2 generic types: R is the response type, T is the request data object type.
 * @param endpoint - URL that comes after the baseurl
 * @param config - the request object see {@link IHttpRequestConfig}
 * @returns Promise<R>
 */
const client = async <R = unknown, T = undefined>(
  endpoint: string,
  {
    data,
    method,
    headers = {
      'Content-Type': 'application/json'
    },
    ...rest
  }: IHttpRequestConfig<T>
): Promise<R> => {
  const config: AxiosRequestConfig<T> = {
    method,
    data,
    baseURL: process.env.REACT_APP_API_URL,
    url: endpoint,
    headers: {
      ...headers
    },
    ...rest
  };

  try {
    const response = await axios(config);
    return response.data;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (err: any) {
    return Promise.reject(err);
  }
};

export { client, axios };
